import type { FC } from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { usePopover } from 'src/hooks/use-popover';

import { AccountPopover } from './account-popover';
import { useSelector } from 'react-redux';

export const AccountButton: FC = () => {
  const popover = usePopover<HTMLButtonElement>();
  const user = useSelector((state: any) => state.getTherapistProfileReducer?.response?.data);
  return (
    <>
      {
        <Box
          component={ButtonBase}
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
          sx={{
            alignItems: 'center',
            display: 'flex',
            borderWidth: 2,
            borderStyle: 'solid',
            borderColor: 'divider',
            height: 40,
            width: 40,
            borderRadius: '50%',
          }}
        >
          <Avatar
            sx={{
              height: 32,
              width: 32,
            }}
          >
            {user?.currentPermissions?.includes('Physician Dashboard') ? (
              <>{`${user?.firstName?.toUpperCase().charAt(0)}`}</>
            ) : user?.firstName && user?.lastName ? (
              `${user?.lastName?.toUpperCase().charAt(0)}${user?.firstName.toUpperCase().charAt(0)}`
            ) : (
              'T'
            )}
          </Avatar>
        </Box>
      }

      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
